import { defineMessages } from "react-intl";

const messages = {
  emailSent: { id: "ForgotPassword.emailSent" }
};

const definedMessages = defineMessages(messages);

export default definedMessages;
